import React from 'react';
import { ResponsiveContainer, AreaChart, Area, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';

const fmtDay = (d) => new Date(`${d}T00:00:00`).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
const axis = { fontSize: 11, fill: '#5a6786' };
const tip = { borderRadius: 10, border: '1px solid #e4e9f4', boxShadow: '0 8px 20px rgba(11,42,107,0.08)', fontSize: 12 };

export const ViewsChart = ({ data }) => (
  <ResponsiveContainer width="100%" height="100%">
    <AreaChart data={data} margin={{ top: 8, right: 8, left: -20, bottom: 0 }}>
      <defs>
        <linearGradient id="jbssViews" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#0b2a6b" stopOpacity={0.3} />
          <stop offset="100%" stopColor="#0b2a6b" stopOpacity={0} />
        </linearGradient>
      </defs>
      <CartesianGrid stroke="#eef2f9" vertical={false} />
      <XAxis dataKey="date" tickFormatter={fmtDay} tick={axis} axisLine={false} tickLine={false} interval="preserveStartEnd" minTickGap={24} />
      <YAxis allowDecimals={false} tick={axis} axisLine={false} tickLine={false} />
      <Tooltip contentStyle={tip} labelFormatter={fmtDay} formatter={(v) => [v, 'Views']} />
      <Area type="monotone" dataKey="views" stroke="#0b2a6b" strokeWidth={3} fill="url(#jbssViews)"
        activeDot={{ r: 5, fill: '#c89b2a', stroke: '#fff', strokeWidth: 2 }} />
    </AreaChart>
  </ResponsiveContainer>
);

export const DonationsChart = ({ data }) => (
  <ResponsiveContainer width="100%" height="100%">
    <BarChart data={data} margin={{ top: 8, right: 8, left: -10, bottom: 0 }}>
      <CartesianGrid stroke="#eef2f9" vertical={false} />
      <XAxis dataKey="date" tickFormatter={fmtDay} tick={axis} axisLine={false} tickLine={false} interval="preserveStartEnd" minTickGap={24} />
      <YAxis tick={axis} axisLine={false} tickLine={false} tickFormatter={(v) => `₹${v >= 1000 ? `${+(v / 1000).toFixed(1)}k` : v}`} />
      <Tooltip contentStyle={tip} cursor={{ fill: 'rgba(200,155,42,0.12)' }} labelFormatter={fmtDay}
        formatter={(v) => [`₹${Number(v).toLocaleString('en-IN')}`, 'Donations']} />
      <Bar dataKey="donations" fill="#c89b2a" radius={[4, 4, 0, 0]} maxBarSize={22} />
    </BarChart>
  </ResponsiveContainer>
);
